export const erpRoutes = [

        { path:'erp/contract/expend-contract',name:'Erp-Expend-Contract',
            component: resolve => require(['@/views/erp/contract/ExpendContract.vue'], resolve),props:true,
            meta:{compPath:'/erp/contract/ExpendContract.vue'}
        },
        { path:'erp/contract/store-contract',name:'Erp-Store-Contract',
            component: resolve => require(['@/views/erp/contract/StoreContract.vue'], resolve),props:true,
            meta:{compPath:'/erp/contract/StoreContract.vue'}
        },

    ]
;